'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import AppLink from '@/components/elementary/AppLink';
import { BasicImage } from '@/components/page-builder/components/BasicImage';
import { createTrackingContext } from '@/lib/analytics/analytics';
import { cn } from '@/lib/styles';
import type { PricingCtaSection } from '@/types/api/pricing.types';
export const PlanCallToAction = t0 => {
  const $ = _c(11);
  const {
    button,
    className,
    linkClassName,
    planTitle,
    section
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("px-3.75", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== button?.icon || $[3] !== button?.link || $[4] !== linkClassName || $[5] !== planTitle || $[6] !== section) {
    t2 = button?.link?.href && <AppLink variant="primary" inverted={true} size="large" link={button?.link} className={cn("w-full shrink-0", linkClassName)} trackingContext={createTrackingContext({
      plan: planTitle,
      planSection: section
    })}>{button?.icon ? <div className="relative size-6 shrink-0"><BasicImage fill={true} loading="lazy" component={button?.icon} className="object-contain" /></div> : null}{button?.link?.label}</AppLink>;
    $[2] = button?.icon;
    $[3] = button?.link;
    $[4] = linkClassName;
    $[5] = planTitle;
    $[6] = section;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};